import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

export const LayoutContext = createContext();

export const useLayoutContext = () => useContext(LayoutContext);

export const LayoutProvider = ({ pageType, children }) => {
  const layoutValues = { pageType };
  return (<LayoutContext.Provider value={layoutValues}>
    {children}
  </LayoutContext.Provider>);
};

LayoutProvider.propTypes = {
  pageType: PropTypes.string,
  children: PropTypes.node.isRequired,
};
